import { render, staticRenderFns } from "./copyTodoModal.vue?vue&type=template&id=63438dc4&"
import script from "./copyTodoModal.vue?vue&type=script&lang=ts&"
export * from "./copyTodoModal.vue?vue&type=script&lang=ts&"
import style0 from "./copyTodoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports